import { render, staticRenderFns } from "./sigblock.vue?vue&type=template&id=a1b27b56&"
import script from "./sigblock.vue?vue&type=script&lang=js&"
export * from "./sigblock.vue?vue&type=script&lang=js&"
import style0 from "./sigblock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports